/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, count: NonNullable<unknown> }} Offers_Per_WeeksInputs */

const en_offers_per_weeks = /** @type {(inputs: Offers_Per_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} every ${i?.count} weeks`)
};

const pl_offers_per_weeks = /** @type {(inputs: Offers_Per_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} co ${i?.count} tyg.`)
};

/**
* | output |
* | --- |
* | "{price} every {count} weeks" |
*
* @param {Offers_Per_WeeksInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_per_weeks = /** @type {((inputs: Offers_Per_WeeksInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Per_WeeksInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_per_weeks(inputs)
	return en_offers_per_weeks(inputs)
});